<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card-title class="pb-5">
              <!--                                    v-if="$can('transaction_create')"-->
              <v-btn :to="{name:'users'}" rounded color="#A5668B" class="text-white">
                <v-icon>mdi-backspace-reverse-outline</v-icon>
                بازگشت
              </v-btn>
              <v-spacer/>
            ویرایش کیف پول
              <v-spacer/>
              <v-btn @click="updateUser" color="#50858B" rounded
                     class="text-white">
                <v-icon>mdi-content-save</v-icon>
                ذخیره
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>

            <v-card-text class="pt-6">
              <v-row>
                <v-flex xs12 sm12 md6 lg6 xl4 class="p-2">
                  <v-row>
                    <v-col>
                      <v-radio-group
                          v-model="row"
                          row
                      >
                        <v-radio
                            label="واریز"
                            value="deposit"
                        ></v-radio>
                        <v-radio
                            label="برداشت"
                            value="withdraw"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>

                    <v-col>
                      <v-chip
                          class="ma-2"
                          color="primary"
                          label
                      >
                        موجودی:
                        <v-icon left>
                          mdi-wallet
                        </v-icon>
                        {{ this.price(pricee) }} ریال
                      </v-chip>
                    </v-col>

                  </v-row>



                </v-flex>
              </v-row>

              <v-row>
                <v-flex xs12 sm12 md12 lg12 xl4 class="p-2">


                  <price-input :dense="true" :label="'قیمت'" v-model="pricee"></price-input>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import RolePicker from "@/view/pages/pickers/rolePicker";
import PriceInput from "@/view/pages/pickers/priceInput";

export default {
  name: "Edit",
  components: {RolePicker,PriceInput},
  props: ['id'],
  data() {
    return {
      name: null,
      email: null,
      phone: null,
      role: null,
      pricee:null,
      roles:null,
      walletData:null,
      username: null,
      password: '',
      row: null,

    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
    this.findUser();
  },
  methods: {
    findUser() {
      this.requestApiPost('admin/wallet/walletInfo',{'user_id':this.id}).then(({data}) => {
        this.pricee = data.balance;
      });
    },

    updateUser() {


      this.requestApiPost(`admin/wallet/transfer`, {
        //deposit=variz
        to:this.row==='deposit'?2:this.id,
        from:this.row==='deposit'?this.id:2,
        amount:this.pricee.replace(/,/g,''),
        role: this.role
      }).then(({data}) => {
        this.$toast.success('کیف پول کاربر با موفقیت ویرایش شد.');
        this.$router.push({name: 'users'})
      })
    }



  }

}
</script>

<style scoped>

</style>